import type { SubscriptionStatus } from '@/modules/subscriptions/types';

/** Row returned by GET /api/v1/admin/subscriptions (snake_case). */
export interface AdminSubscriptionMonitorItem {
  subscription_id: string;
  tenant_id: string;
  tenant_name: string;
  customer_name: string | null;
  customer_email: string | null;
  customer_phone: string | null;
  product_id: string;
  product_slug: string;
  product_name: string;
  plan_id: string;
  plan_name: string;
  subscription_status: SubscriptionStatus;
  entitlement_status: string | null;
  trial_status: string | null;
  trial_ends_at: string | null;
  started_at: string;
  current_period_end: string;
  days_remaining: number | null;
  last_payment_status: string | null;
  last_payment_amount: number | null;
  last_payment_currency: string | null;
  last_payment_provider: string | null;
  last_payment_provider_label: string | null;
  last_payment_at: string | null;
  has_payment_issue: boolean;
  created_at: string;
  updated_at: string;
}

export interface AdminSubscriptionsMonitorListResponse {
  items: AdminSubscriptionMonitorItem[];
  next_cursor: string | null;
  total: number;
}

export interface ListAdminSubscriptionsMonitorQuery {
  status?: SubscriptionStatus;
  product_id?: string;
  product_slug?: string;
  plan_id?: string;
  tenant_id?: string;
  entitlement_status?: string;
  search?: string;
  expiring_soon_days?: number;
  payment_issue?: boolean;
  from?: string;
  to?: string;
  cursor?: string;
  limit?: number;
}

export const SUBSCRIPTION_MONITOR_STATUSES: SubscriptionStatus[] = [
  'trialing',
  'active',
  'past_due',
  'suspended',
  'expired',
  'cancelled',
];

export const ENTITLEMENT_STATUS_OPTIONS = ['inactive', 'active', 'suspended', 'revoked'] as const;
